import axios from "axios";
import { baseurl } from "domain";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Icon from "@mui/material/Icon";
import team2 from "assets/images/team-2.jpg";
import { useState } from "react";

// Define Author component
const Author = ({ image, name, email }) => (
  <MDBox display="flex" alignItems="center" lineHeight={1}>
    <MDAvatar src={image} name={name} size="sm" />
    <MDBox ml={2} lineHeight={1}>
      <MDTypography display="block" variant="caption" color="text" fontWeight="medium">
        {name}
      </MDTypography>
      <MDTypography variant="button">{email}</MDTypography>
    </MDBox>
  </MDBox>
);

Author.propTypes = {
  image: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
};

// Define Job component
const Job = ({ title }) => (
  <MDBox lineHeight={1} textAlign="left">
    <MDTypography variant="button" fontWeight="medium">
      {title}
    </MDTypography>
  </MDBox>
);

Job.propTypes = {
  title: PropTypes.string.isRequired,
};

async function authorsTableData(filters, handleClickView, handleClickDelete, handleEditClick) {
  let data = [];

  try {
    const response = await axios.post(`https://${baseurl}/filterSpecialDays`, filters);
    data = response.data.specialDays;
  } catch (error) {
    console.error("Error fetching filtered data:", error);
  }

  const columns = [
    { Header: "Special Day Name", accessor: "specialDayName", align: "left" },
    { Header: "Date", accessor: "date", align: "left" },
    { Header: "Delete", accessor: "Delete", align: "center" },
  ];

  const rows = data
    .filter((user) => user.designation !== "system")
    .map((user) => ({
      specialDayName: <Job title={user.specialDayName} />,
      date: <Job title={user.date} />,
      Delete: (
        <MDButton variant="text" color="error" onClick={() => handleClickDelete(user.spid)}>
          <Icon>delete</Icon>&nbsp;delete
        </MDButton>
      ),
    }));

  return { columns, rows };
}

export default authorsTableData;
